export const messages = {
  en: {
    printRepairDetail: {
      repairId: 'Repair ID:',
      printTime: 'Print Time:',
      repairInfo: 'Repair Information',
      repairName: 'Repairer:',
      tel: 'Contact Number:',
      location: 'Location:',
      context: 'Repair Content:',
      maintenanceType: 'Repair Type:',
      paidService: 'Paid Service',
      freeService: 'Free Service',
      repairMaterials: 'Repair Materials:',
      repairFee: 'Cost Details:',
      yuan: 'Yuan',
      workflow: 'Work Order Flow',
      serialNumber: 'No.',
      handler: 'Handler',
      status: 'Status',
      processTime: 'Process Time',
      timeConsuming: 'Time Consuming',
      comment: 'Comment',
      remark: 'Remark',
      repairerSign: 'Repairer Signature',
      customerSign: 'Customer Signature',
      time: 'Time',
      page: {
        title: 'Repair Work Order',
        subtitle: 'Printable repair work order with processing flow and signatures'
      }
    }
  },
  zh: {
    printRepairDetail: {
      repairId: '报修单号：',
      printTime: '打印时间：',
      repairInfo: '报修信息',
      repairName: '报修人：',
      tel: '联系电话：',
      location: '位置：',
      context: '报修内容：',
      maintenanceType: '报修类型：',
      paidService: '有偿服务',
      freeService: '无偿服务',
      repairMaterials: '报修用料：',
      repairFee: '费用明细：',
      yuan: '元',
      workflow: '工单流转',
      serialNumber: '序号',
      handler: '处理人',
      status: '状态',
      processTime: '处理时间',
      timeConsuming: '耗时',
      comment: '意见',
      remark: '备注',
      repairerSign: '维修人员签字',
      customerSign: '客户签字',
      time: '时间',
      page: {
        title: '报修工单',
        subtitle: '可打印的报修工单，含流转记录与签字栏'
      }
    }
  }
}